import React from "react";

export default (props) => (
    <div className={`action-container ${props.addClass}`}>
        <div className="action-loader">
            <img className="loading-img"
                 src={`${process.env.PUBLIC_URL}/images/loader/LoaderBigNew.gif`}
                 alt="loading"/>
        </div>
    </div>
)